var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 12.6667C13.3065 12.6667 15.9998 9.97342 15.9998 6.66675C15.9998 3.36008 13.3065 0.666748 9.99984 0.666748C6.69317 0.666748 3.99984 3.36008 3.99984 6.66675C3.99984 9.97342 6.69317 12.6667 9.99984 12.6667ZM9.99984 3.33341C11.8398 3.33341 13.3332 4.82675 13.3332 6.66675C13.3332 8.50675 11.8398 10.0001 9.99984 10.0001C8.15984 10.0001 6.6665 8.50675 6.6665 6.66675C6.6665 4.82675 8.15984 3.33341 9.99984 3.33341Z",
    fill: "#676A71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 14.0001H5.99984C3.05317 14.0001 0.666504 16.3867 0.666504 19.3334V20.6667C0.666504 23.6134 3.05317 26.0001 5.99984 26.0001H13.9998C16.9465 26.0001 19.3332 23.6134 19.3332 20.6667V19.3334C19.3332 16.3867 16.9465 14.0001 13.9998 14.0001ZM16.6665 20.6667C16.6665 22.1334 15.4665 23.3334 13.9998 23.3334H5.99984C4.53317 23.3334 3.33317 22.1334 3.33317 20.6667V19.3334C3.33317 17.8667 4.53317 16.6667 5.99984 16.6667H13.9998C15.4665 16.6667 16.6665 17.8667 16.6665 19.3334V20.6667Z",
    fill: "#676A71"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.5cda0b1a5008e98c44174f77c85c7996.svg";
export { ForwardRef as ReactComponent };